import { h } from 'preact';
import clsx from 'clsx';
import { useEffect } from 'preact/hooks';

const ProductStickyButton = ({
  product,
  variant,
  options,
  isVisible,
  children,
}) => {
  useEffect(() => {
    if (isVisible) {
      document.body.classList.add('sticky-product');
    } else {
      document.body.classList.remove('sticky-product');
    }
    return () => {
      document.body.classList.remove('sticky-product');
    };
  }, [isVisible]);

  return (
    <div
      className={clsx(
        'lc:border-t border-grey-400 ml:shadow-[0_-1px_44px_0_rgba(0,0,0,0.25)] fixed bottom-0 left-0 w-full flex bg-white gap-24 z-40',
        {
          'ease-in duration-300 translate-y-full': !isVisible,
          'ease-out duration-300 translate-y-0': isVisible,
        },
      )}
    >
      {!variant && !!product.images.length && (
        <img
          src={product.images[0].src}
          alt={product.images[0].alt}
          className="w-60 object-cover h-auto hidden tablet:block"
        />
      )}
      {!!variant && !!product.images.length && (
        <img
          src={variant.image.src}
          alt={variant.image.alt}
          className="w-60 object-cover h-auto hidden tablet:block"
        />
      )}
      <div className="px-24 tablet:px-0 tablet:flex items-center flex-1 min-w-0 gap-24 tablet:pr-50 ml:tablet:pr-24">
        <div className="flex-1 min-w-0 hidden tablet:block">
          <div className="display-4">{product.title}</div>
          <div className="body-2 text-subdued">
            {!product.hasOnlyDefaultVariant &&
              options
                .filter((i) => i.value)
                .map((i) => i.value)
                .join(', ')}
          </div>
        </div>
        <div className="[&>div]:tablet:flex [&>div]:tablet:flex-row-reverse [&_.button]:tablet:w-[427px] [&_.atc-container]:ml:lg:py-16">
          {children}
        </div>
      </div>
    </div>
  );
};

export default ProductStickyButton;
